import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

/**
 * The Page Meta component adds all the necessary tags for page meta needs. It cooresponds to the PageMeta content type.
 */

const PageMeta = (props) => {
  const { title, type, description, image, children } = props;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image.file.url} />}
      {children}
    </Helmet>
  );
};

PageMeta.defaultProps = {
  children: null,
  image: null
};

PageMeta.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['article', 'website']).isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
  children: PropTypes.node,
};

export default PageMeta;
